/* euroguard · Test «Encuentra tu filtro» (sections/eg-quiz.liquid)
   - Preguntas (fieldsets) con respuestas reales (radio / checkbox); una pregunta por pantalla, con atrás, barra de progreso
     y salto automático en las de una respuesta.
   - Puntuación: cada respuesta suma puntos por resultado (data-points «grifo:2 gravedad:1») y activa marcas
     (data-flags «cal, people:3-4»). Gana el resultado con más puntos; el segundo sale como alternativa; los extras
     (ducha) aparecen si su marca está activa.
   - La variante se resuelve con «data-variant-match» ([size] y [model] vienen de los mapas de tamaño y cartucho).
   - «Añadir al carrito» usa window.egCartDrawer.add(items) si existe (carrito lateral); si no, /cart/add.js y /cart.
   - El correo opcional guarda el estado en sessionStorage antes de enviar el formulario nativo y lo restaura al volver
     con ?customer_posted=true. ?r=<clave> preselecciona esa respuesta (bloque de entrada de la portada). */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const norm = s => String(s ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
const escapeHtml = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function parsePoints(str) {
  const out = {}; const re = /([a-z0-9_-]+)\s*[:=]\s*(-?\d+)/gi; let m;
  while ((m = re.exec(String(str || '')))) out[m[1].toLowerCase()] = (out[m[1].toLowerCase()] || 0) + Number(m[2]);
  return out;
}
function parseFlags(str) { return String(str || '').split(/[,\s]+/).map(t => t.trim().toLowerCase()).filter(Boolean); }
/* «clave=valor|texto» por línea → [{key, value, label}] */
function parseMap(text) {
  return String(text || '').split(/\r?\n/).map(l => l.trim()).filter(Boolean).map(l => {
    const eq = l.indexOf('='); if (eq < 0) return null;
    const key = l.slice(0, eq).trim().toLowerCase(); const rest = l.slice(eq + 1); const bar = rest.indexOf('|');
    return { key, value: (bar < 0 ? rest : rest.slice(0, bar)).trim(), label: (bar < 0 ? rest : rest.slice(bar + 1)).trim() };
  }).filter(Boolean);
}
/* Mismo formato que Liquid | money (Configuración › Moneda) */
function moneyFormatter(fmt) {
  const m = String(fmt || '').match(/\{\{\s*(\w+)\s*\}\}/);
  return cents => {
    if (!m) { try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' €'; } }
    const key = m[1], decimals = key.includes('no_decimals') ? 0 : 2;
    let thousands = ',', decimal = '.';
    if (key.includes('comma_separator')) { thousands = '.'; decimal = ','; }
    else if (key.includes('apostrophe_separator')) { thousands = "'"; decimal = '.'; }
    else if (key.includes('period_and_space_separator')) { thousands = ' '; decimal = '.'; }
    else if (key.includes('space_separator')) { thousands = ' '; decimal = ','; }
    const fixed = (Math.round(Number(cents) || 0) / 100).toFixed(decimals).split('.');
    const whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fmt.replace(m[0], decimals ? whole + decimal + fixed[1] : whole);
  };
}

class Quiz {
  constructor(root) {
    this.root = root;
    this.form = $('[data-eg-quiz-form]', root);
    this.money = moneyFormatter(root.dataset.moneyFormat);
    this.stepEl = $('[data-eg-quiz-step]', root); this.barEl = $('[data-eg-quiz-bar]', root);
    this.resultsEl = $('[data-eg-quiz-results]', root); this.card = $('[data-eg-quiz-card]', root);
    this.storeKey = 'egQuiz:' + (root.dataset.section || 'quiz');
    this.autoadvance = root.dataset.autoadvance !== 'false';
    this.questions = $$('[data-eg-quiz-q]', this.form).map(el => ({ el, key: el.dataset.egQuizQ, multi: el.dataset.multi === 'true', skip: parseFlags(el.dataset.skipFlags), inputs: $$('input', el) }));
    this.results = $$('[data-eg-quiz-result]', root).map(el => {
      let data = {}; try { data = JSON.parse($('[data-eg-quiz-data]', el).textContent); } catch (e) { console.error('eg-quiz: datos del resultado', e); }
      return { el, key: el.dataset.egQuizResult, addon: el.dataset.addon === 'true', addonFlag: norm(el.dataset.addonFlag), match: el.dataset.variantMatch || '', data, sizeMap: parseMap(data.sizeMap), modelMap: parseMap(data.modelMap), plan: 'sub', variant: null };
    });
    this.index = 0; this.timer = null; this.done = false;
    this.bind();
    this.boot();
  }

  /* ---------- estado ---------- */
  answers() { const out = {}; this.questions.forEach(q => { out[q.key] = q.inputs.filter(i => i.checked).map(i => i.value); }); return out; }
  checkedInputs() { return this.questions.flatMap(q => q.inputs.filter(i => i.checked)); }
  flags() { const set = new Set(); this.checkedInputs().forEach(i => parseFlags(i.dataset.flags).forEach(f => set.add(f))); return set; }
  flagValue(prefix) { for (const f of this.flags()) if (f.startsWith(prefix + ':')) return f.slice(prefix.length + 1); return ''; }
  scores() { const s = {}; this.checkedInputs().forEach(i => { const p = parsePoints(i.dataset.points); Object.keys(p).forEach(k => { s[k] = (s[k] || 0) + p[k]; }); }); return s; }
  visible() { const flags = this.flags(); return this.questions.filter(q => !q.skip.some(f => flags.has(f))); }

  /* ---------- navegación ---------- */
  bind() {
    this.form.addEventListener('submit', e => e.preventDefault());
    this.form.addEventListener('change', e => {
      const input = e.target.closest('input'); if (!input) return;
      const q = this.questions.find(x => x.inputs.includes(input));
      q.el.classList.remove('is-invalid');
      this.save();
      if (this.autoadvance && q && !q.multi) { clearTimeout(this.timer); this.timer = setTimeout(() => this.next(), 260); }
    });
    this.root.addEventListener('click', e => {
      if (e.target.closest('[data-eg-quiz-next]')) { clearTimeout(this.timer); this.next(); }
      else if (e.target.closest('[data-eg-quiz-back]')) { clearTimeout(this.timer); this.back(); }
      else if (e.target.closest('[data-eg-quiz-restart]')) this.restart();
      else if (e.target.closest('[data-eg-quiz-add]')) { const art = e.target.closest('[data-eg-quiz-result]'); const r = this.results.find(x => x.el === art); if (r) this.add(r, e.target.closest('[data-eg-quiz-add]')); }
    });
    this.root.addEventListener('change', e => {
      const radio = e.target.closest('[data-eg-quiz-plans] input'); if (!radio) return;
      const art = radio.closest('[data-eg-quiz-result]'); const r = this.results.find(x => x.el === art); if (!r) return;
      r.plan = radio.value;
      $$('.eg-quiz__plan', art).forEach(l => l.classList.toggle('is-active', $('input', l).checked));
      this.save();
    });
    const emailForm = $('[data-eg-quiz-email-form]', this.root);
    if (emailForm) emailForm.addEventListener('submit', () => { this.setTags(); this.save(); });
  }
  show(i) {
    const list = this.visible(); if (!list.length) return;
    this.index = Math.max(0, Math.min(i, list.length - 1));
    this.done = false;
    this.resultsEl.hidden = true;
    this.questions.forEach(q => { q.el.hidden = true; });
    const q = list[this.index]; q.el.hidden = false;
    $('[data-eg-quiz-back]', q.el).disabled = this.index === 0;
    const label = (this.root.dataset.stepLabel || 'Question [n] sur [total]').replace('[n]', this.index + 1).replace('[total]', list.length);
    if (this.stepEl) this.stepEl.textContent = label;
    if (this.barEl) this.barEl.style.width = Math.round((this.index / list.length) * 100) + '%';
    this.root.classList.remove('is-done');
    const first = q.inputs.find(x => x.checked) || q.inputs[0];
    if (first && this.interacted) first.focus({ preventScroll: true });
    if (this.interacted) this.scrollTop();
  }
  next() {
    this.interacted = true;
    const list = this.visible(); const q = list[this.index]; if (!q) return;
    if (!q.inputs.some(x => x.checked)) { q.el.classList.add('is-invalid'); (q.inputs[0] || q.el).focus({ preventScroll: true }); return; }
    const after = this.visible(); // las marcas pueden haber ocultado preguntas
    const pos = after.indexOf(q);
    if (pos + 1 < after.length) this.show(pos + 1); else this.finish();
  }
  back() {
    this.interacted = true;
    if (this.done) { const list = this.visible(); this.show(list.length - 1); return; }
    if (this.index > 0) this.show(this.index - 1);
  }
  restart() {
    this.interacted = true;
    this.questions.forEach(q => q.inputs.forEach(i => { i.checked = false; }));
    this.results.forEach(r => { r.el.hidden = true; r.plan = 'sub'; });
    try { sessionStorage.removeItem(this.storeKey); } catch (e) { /* sin almacenamiento */ }
    this.show(0);
  }
  scrollTop() {
    const top = this.card.getBoundingClientRect().top + window.scrollY - 96;
    if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  /* ---------- resultado ---------- */
  finish() {
    const scores = this.scores(), flags = this.flags();
    const main = this.results.filter(r => !r.addon);
    if (!main.length) return;
    const ranked = main.map(r => ({ r, score: scores[r.key] || 0 })).sort((a, b) => b.score - a.score || main.indexOf(a.r) - main.indexOf(b.r));
    const winner = ranked.find(x => x.score >= 0) || ranked[0];
    const runner = ranked.find(x => x.r !== winner.r && x.score > 0) || null;
    const addons = this.results.filter(r => r.addon && r.addonFlag && flags.has(r.addonFlag));
    this.questions.forEach(q => { q.el.hidden = true; });
    this.results.forEach(r => { r.el.hidden = true; });
    this.render(winner.r, true);
    addons.forEach(r => this.render(r, false));
    this.renderRunner(runner ? runner.r : null);
    this.setTags(winner.r.key);
    if (this.stepEl) this.stepEl.textContent = '';
    if (this.barEl) this.barEl.style.width = '100%';
    this.resultsEl.hidden = false;
    this.root.classList.add('is-done');
    this.done = true; this.winner = winner.r;
    this.save();
    if (this.interacted) { this.scrollTop(); const h = $('[data-eg-quiz-title]', winner.r.el); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
    document.dispatchEvent(new CustomEvent('eg-quiz:result', { detail: { result: winner.r.key, runner: runner ? runner.r.key : null, addons: addons.map(a => a.key), answers: this.answers(), scores } }));
  }
  placeholders(r) {
    const people = this.flagValue('people');
    const size = r.sizeMap.find(m => m.key === people) || null;
    const flags = this.flags();
    const model = r.modelMap.find(m => m.key !== '*' && flags.has(m.key)) || r.modelMap.find(m => m.key === '*') || null;
    return { '[size]': size ? (size.label || size.value) : '', '[size_value]': size ? size.value : '', '[model]': model ? model.value : '', '[model_value]': model ? model.value : '', '[model_reason]': model ? (model.label || model.value) : '', '[people]': people.replace('-', '–').replace('+', ' ou plus') };
  }
  fill(text, ph) { let s = String(text || ''); Object.keys(ph).forEach(k => { s = s.split(k).join(ph[k]); }); return s.replace(/\s+·\s*$/, '').replace(/\s{2,}/g, ' ').trim(); }
  pickVariant(r, ph) {
    const variants = r.data.variants || [];
    const values = Object.assign({}, ph, { '[size]': ph['[size_value]'], '[model]': ph['[model_value]'] }); // para casar variantes cuentan los valores de la opción, no los textos
    const required = r.match.split(',').map(t => this.fill(t, values)).map(norm).filter(Boolean);
    const matches = variants.filter(v => required.every(req => (v.options || []).some(o => norm(o) === req)));
    const pool = matches.length ? matches : variants;
    return pool.find(v => v.available) || pool[0] || null;
  }
  render(r, isMain) {
    const ph = this.placeholders(r);
    const variant = this.pickVariant(r, ph); r.variant = variant;
    const title = this.fill(r.data.title, ph);
    const h = $('[data-eg-quiz-title]', r.el); if (h) h.textContent = title;
    const vline = $('[data-eg-quiz-variant]', r.el);
    if (vline) {
      const parts = [];
      if (ph['[size]']) parts.push(ph['[size]']);
      if (ph['[model_value]'] && r.match.includes('[model]')) parts.push(ph['[model_value]']);
      if (!parts.length && variant && variant.title && variant.title !== 'Default Title' && (r.data.variants || []).length > 1) parts.push(variant.title.replace(/\s*\/\s*/g, ' · '));
      const shown = parts.filter(p => !title.toLowerCase().includes(p.toLowerCase())); // no repetir lo que ya dice el título
      vline.textContent = shown.join(' · '); vline.hidden = !shown.length;
    }
    $$('[data-eg-quiz-reason]', r.el).forEach(li => { const txt = this.fill(li.dataset.egQuizReason, ph); li.hidden = !txt; $('span', li).textContent = txt; });
    const price = $('[data-eg-quiz-price]', r.el), compare = $('[data-eg-quiz-compare]', r.el);
    if (price && variant) { price.textContent = this.money(variant.price); if (compare) { const show = variant.compare > variant.price; compare.hidden = !show; compare.textContent = show ? this.money(variant.compare) : ''; } }
    const because = $('[data-eg-quiz-because]', r.el);
    if (because) {
      const chips = this.checkedInputs().map(i => i.dataset.label).filter(Boolean);
      $('[data-eg-quiz-chips]', because).innerHTML = chips.map(c => `<i>${escapeHtml(c)}</i>`).join('');
      because.hidden = !chips.length || !isMain;
    }
    const view = $('[data-eg-quiz-view]', r.el);
    if (view && variant && (r.data.variants || []).length > 1) view.href = r.data.url + (r.data.url.includes('?') ? '&' : '?') + 'variant=' + variant.id;
    const btn = $('[data-eg-quiz-add]', r.el); if (btn) { btn.disabled = !variant || !variant.available; if (variant && !variant.available) btn.textContent = 'Épuisé'; }
    $('[data-eg-quiz-add-error]', r.el).hidden = true;
    r.el.hidden = false;
  }
  renderRunner(r) {
    const box = $('[data-eg-quiz-runner]', this.root); if (!box) return;
    if (!r) { box.hidden = true; return; }
    const ph = this.placeholders(r); const variant = this.pickVariant(r, ph);
    $('[data-eg-quiz-runner-title]', box).textContent = this.fill(r.data.title, ph);
    const img = $('[data-eg-quiz-runner-img]', box); if (r.el.dataset.image) { img.src = r.el.dataset.image; img.hidden = false; } else img.hidden = true;
    $('[data-eg-quiz-runner-link]', box).href = r.data.url + (variant && (r.data.variants || []).length > 1 ? (r.data.url.includes('?') ? '&' : '?') + 'variant=' + variant.id : '');
    box.hidden = false;
  }

  /* ---------- carrito ---------- */
  items(r) {
    const offer = r.data.offer;
    if (offer && offer.plan) {
      if (offer.kit) { // oferta actual: kit (filtro gratis + cartuchos) con plan de venta; Recharge lo cambia por el cartucho al renovar
        return r.plan === 'one' ? [{ id: Number(offer.paid), quantity: 1 }] : [{ id: Number(offer.kit), quantity: 1, selling_plan: Number(offer.plan) }];
      }
      const group = 'eg-offer-' + (window.crypto?.randomUUID ? crypto.randomUUID() : Date.now().toString(36));
      if (r.plan === 'one') return [{ id: Number(offer.paid), quantity: 1, properties: { Plan: offer.oneLabel || 'Achat unique' } }];
      const base = { _offer_source: offer.source || 'eg-pdp-faucet', _offer_group: group, Plan: offer.label || '' };
      return [ // cartridges with the plan first, then the free filter (same order as the real orders / PDP)
        { id: Number(offer.addon), quantity: Number(offer.qty) || 1, selling_plan: Number(offer.plan), properties: Object.assign({ _offer_role: 'addon' }, base) },
        { id: Number(offer.free), quantity: 1, properties: Object.assign({ _offer_role: 'main' }, base) },
      ];
    }
    return r.variant ? [{ id: Number(r.variant.id), quantity: 1 }] : [];
  }
  async add(r, btn) {
    const items = this.items(r); if (!items.length || btn.dataset.busy) return;
    const label = btn.firstChild, original = label.textContent; const err = $('[data-eg-quiz-add-error]', r.el);
    btn.dataset.busy = '1'; btn.setAttribute('aria-busy', 'true'); label.textContent = this.root.dataset.addingLabel || '…'; if (err) err.hidden = true;
    const reset = ok => { delete btn.dataset.busy; btn.removeAttribute('aria-busy'); label.textContent = ok ? (this.root.dataset.addedLabel || original) : original; if (ok) setTimeout(() => { label.textContent = original; }, 2500); };
    try {
      if (window.egCartDrawer) { await window.egCartDrawer.add(items); reset(true); return; }
      const res = await fetch((this.root.dataset.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      location.href = this.root.dataset.cartUrl || '/cart';
    } catch (e) {
      console.error(e); if (err) err.hidden = false; reset(false);
    }
  }

  /* ---------- correo y persistencia ---------- */
  setTags(winnerKey) {
    const input = $('[data-eg-quiz-tags]', this.root); if (!input) return;
    const prefix = this.root.dataset.tagPrefix || 'quiz'; const key = winnerKey || (this.winner && this.winner.key);
    const tags = [prefix]; if (key) tags.push(prefix + ':' + key);
    this.checkedInputs().forEach(i => tags.push(prefix + '-r:' + i.value));
    input.value = tags.join(', ');
  }
  save() {
    try { sessionStorage.setItem(this.storeKey, JSON.stringify({ answers: this.answers(), plans: Object.fromEntries(this.results.map(r => [r.key, r.plan])), done: this.done })); } catch (e) { /* sin almacenamiento */ }
  }
  restore() {
    let state = null; try { state = JSON.parse(sessionStorage.getItem(this.storeKey) || 'null'); } catch (e) { state = null; }
    if (!state || !state.answers) return false;
    this.questions.forEach(q => { const vals = state.answers[q.key] || []; q.inputs.forEach(i => { i.checked = vals.includes(i.value); }); });
    this.results.forEach(r => { if (state.plans && state.plans[r.key]) { r.plan = state.plans[r.key]; $$('[data-eg-quiz-plans] input', r.el).forEach(i => { i.checked = i.value === r.plan; }); $$('.eg-quiz__plan', r.el).forEach(l => l.classList.toggle('is-active', $('input', l).checked)); } });
    return !!state.done;
  }
  boot() {
    const params = new URLSearchParams(location.search);
    const posted = params.get('customer_posted') === 'true';
    const preset = params.get('r');
    if (posted) {
      const done = this.restore();
      if (done) { this.finish(); return; }
      const note = $('[data-eg-quiz-posted]', this.root); if (note) note.hidden = false;
      this.show(0); return;
    }
    if (preset) {
      const input = this.questions.flatMap(q => q.inputs).find(i => norm(i.value) === norm(preset));
      if (input) {
        input.checked = true;
        const q = this.questions.find(x => x.inputs.includes(input)); const pos = this.visible().indexOf(q);
        this.save();
        this.show(pos + 1 < this.visible().length ? pos + 1 : pos);
        return;
      }
    }
    this.show(0);
  }
}

function init() { $$('[data-eg-quiz]').forEach(el => { if (!el.dataset.ready) { el.dataset.ready = '1'; new Quiz(el); } }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', e => { const el = e.target && e.target.querySelector && e.target.querySelector('[data-eg-quiz]'); if (el) { delete el.dataset.ready; init(); } });
})();
